import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const LINKS = [
  { to: "/founder", label: "Founder" },
  { to: "/philosophy", label: "Philosophy" },
  { to: "/craft", label: "Craft" },
  { to: "/journal", label: "Journal" },
];

export const Nav = () => {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > window.innerHeight * 4.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  const onDarkHero = pathname === "/" && !scrolled;
  const fg = onDarkHero ? "#EFE8DC" : "#2C241E";

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${
        onDarkHero
          ? "bg-transparent border-b border-transparent"
          : "backdrop-blur-xl bg-[#EFE8DC]/85 border-b border-[#2C241E]/10"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between gap-4">
        <Link
          to="/"
          data-testid="nav-logo"
          className="text-xs md:text-sm font-medium tracking-[0.35em] uppercase shrink-0 transition-colors duration-500"
          style={{ color: fg }}
        >
          LIGATEN
        </Link>
        <nav className="hidden md:flex items-center gap-3 md:gap-8 overflow-x-auto">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[9px] md:text-xs font-medium tracking-[0.2em] uppercase whitespace-nowrap transition-colors duration-500"
              style={({ isActive }) => ({
                color: isActive ? fg : `${fg}73`,
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <Link
          to="/join"
          data-testid="nav-join-button"
          className={`shrink-0 rounded-full text-[9px] md:text-xs font-medium tracking-[0.2em] uppercase px-4 md:px-5 py-2.5 transition-[transform,background-color,color,box-shadow] duration-300 hover:scale-[1.03] hover:shadow-lg ${
            onDarkHero
              ? "bg-[#EFE8DC] text-[#2C241E] hover:bg-[#F3F1EB]"
              : "bg-[#2C241E] text-[#EFE8DC] hover:bg-[#3A322C]"
          }`}
        >
          Join the List
        </Link>
      </div>
    </header>
  );
};
